/**
 * The installation's organization agents. Previews of a draft scope live under it too, so
 * invalidating the prefix marks every reach and preview count stale.
 */
export const organizationAgentsQueryKey = (installationId: number | null) =>
  ['organization-agents', installationId] as const;
